import axios from "axios";

const state = {
  listCandidateEvaluationTemplates: null,
};

const mutations = {
  setListCandidateEvaluationTemplates(state, payload) {
    state.listCandidateEvaluationTemplates = payload;
  },
};

const actions = {
  setListCandidateEvaluationTemplates({ commit }, payload) {
    commit("setListCandidateEvaluationTemplates", payload);
  },
  async loadListCandidateEvaluationTemplates({ commit, state, rootState }) {
    if (state.listCandidateEvaluationTemplates) {
      return;
    }
    const res = await axios.get(
      `/api/evaluationtemplates/?agency=${rootState.authentication.agencyID}&user_type=Candidate`
    );
    if (res && res.data) {
      commit('setListCandidateEvaluationTemplates', res.data);
    }
  }
};

const getters = {
  listCandidateEvaluationTemplates(state) {
    return state.listCandidateEvaluationTemplates || [];
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/evaluations.js